import { Bot, ProjectType } from 'ideta-library/lib/common/bot';

import { environment } from '../../environments/environment';

import { AppPage } from '../shared/services/session/core-session.service';

export class ProductUtils {
  static matchingDomain(bot: Partial<Bot>): string {
    switch (bot?.project || 'bot') {
      case 'webhook':
        return environment.products.webhooks;
      case 'livechat':
        return environment.products.livechat;
      case 'bot':
        return environment.products.default;
      default:
        return null;
    }
  }

  /**
   * Checks if the type of project is accessible in this app
   *
   * @param bot
   * @returns
   */
  static accessBot(bot: Partial<Bot>): boolean {
    if (!bot) return false;
    const project: ProjectType = bot.project || 'bot';
    return project === 'bot' || project === 'webhook' || project === 'livechat' || project === 'inbox_link';
  }

  /**
   * Checks if the target page is accessible in this app
   *
   * @param page
   * @returns
   */
  static accessPages(page: AppPage): boolean {
    switch (page) {
      case 'messaging':
      case 'analytics':
      case 'settings':
        return true;
      default:
        return false;
    }
  }
}
